/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

import React from 'react';

const Video = ({ id, title, description, youtubeId }) => {
  return (
    <div id={id} className="bg-stone-200 dark:bg-stone-800 rounded shadow-md p-4">
      <h3 className="text-xl font-bold mb-2">{title}</h3>
      <iframe
        className="w-full h-80"
        src={`https://www.youtube.com/embed/${youtubeId}`}
        frameBorder="0"
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
      <div className="py-4" dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  );
};

const Videos = () => {
  const videos = [
    {
      id: 'vid1',
      title: 'Video 1: Launch InDeep and visualize results',
      description: '<p>This video shows how to use InDeep<sup>Net</sup> to:</p><ul class="list-disc pl-6 space-y-2"><li>Upload a structure from a database</li><li>Select residues by clicking or dragging across the sequence</li><li>Run the analysis</li><li>Visualize results in <strong>Mol*</strong></li></ul>',
      youtubeId: 'UGWhDosylCg?si=L2vDDVhH_eSDz-JD',
    },
    {
      id: 'vid2',
      title: 'Video 2: Evaluate Conformational Hololikeness',
      description: '<p>This video shows how to use InDeep<sup>Net</sup> to:</p><ul class="list-disc pl-6 space-y-2"><li>Use the Isolate residues around druggable sites</li><li>Run hololikeness analysis</li><li>Interpret the results</li></ul>',
      youtubeId: '1vaL3qnRe5s?si=3XYwLQwnhKBD-mxr',
    },
    {
      id: 'vid3',
      title: 'Video 3: Monitor ligandability along molecular dynamics trajectories',
      description: '<p>This video shows how to use InDeep<sup>Net</sup> to:</p><ul class="list-disc pl-6 space-y-2"><li>Upload a trajectory from your computer</li><li>Adjust the volume of the pocket you wish monitor</li><li>Select the residues for which you wish to monitor the ligandability</li><li>Run the analysis</li><li>Monitor the ligandability along the trajectory</li></ul>',
      youtubeId: 'NxDFlmdoX4c?si=pxI1MpTfDa75EfCy',
    },
  ];
  return (
    <div id="vids" className="mx-auto">
      <h2 className="text-2xl font-extrabold text-center text-gray-900 dark:text-white">Videos</h2>
      <div className="flex flex-wrap justify-center">
        {videos.map((video, index) => (
          <div key={index} className="w-full md:w-1/2 xl:w-1/3 p-4">
            <Video
              id={video.id}
              title={video.title}
              description={video.description}
              youtubeId={video.youtubeId}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Videos;